import React from "react";
import InputTextFieldV2 from "../../molecules/input/input-text-field-v2";
import { TReceiptEntity } from "../../types/billing";

const AmountField = ({
  receiptEntity,
  isDisabled = false,
  handleAmountChange,
}: {
  receiptEntity: TReceiptEntity;
  isDisabled?: boolean;
  handleAmountChange: (props: { newAmount: number }) => void;
}) => {
  const { receiptSkus, receipt_amount, net_amount } = receiptEntity;
  const currSkuItem = receiptSkus?.[0];

  const handleInputAmountChange: React.ChangeEventHandler<HTMLInputElement> = (
    e
  ) => {
    const value = e.target.value;
    const amount = Number(value);

    if (isNaN(amount)) return;
    if (!isNaN(amount)) handleAmountChange({ newAmount: amount });
  };

  return (
    <InputTextFieldV2
      value={
        // exising bug. right now in PROD hence falling back to 0
        net_amount || receipt_amount || currSkuItem?.amount.toString() || "0"
      }
      onValueChange={handleInputAmountChange}
      isDisabled={isDisabled}
      paddingClass="px-8 py-7"
      inputClass="w-full pl-24"
      PrefixComponent={() => (
        <div className="absolute text-darwin-neutral-500">Rs.</div>
      )}
    />
  );
};

export default AmountField;
